import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setLevelType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const LevelTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Level"
      id="level_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setLevelType(option.id))
      }}
    />
  )
}
export default LevelTypeDropdown
